var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t(`PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB1`),
            visible: "",
            width: "35%",
          },
          on: { close: _vm.onCancel },
        },
        [
          _c(
            "el-row",
            [
              _c("el-col", { staticClass: "label-class", attrs: { span: 8 } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("exchange_tab1_recevier")) +
                    ":\n            "
                ),
              ]),
              _c(
                "el-col",
                { attrs: { span: 15 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        multiple: "",
                        "value-key": "id",
                        placeholder: _vm.$t("COMMON_SELECT"),
                        "collapse-tags": "",
                      },
                      model: {
                        value: _vm.emailList,
                        callback: function ($$v) {
                          _vm.emailList = $$v
                        },
                        expression: "emailList",
                      },
                    },
                    _vm._l(_vm.emailOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.userName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c("el-col", { staticClass: "label-class", attrs: { span: 8 } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("exchange_tab1_ccer")) +
                    ":\n            "
                ),
              ]),
              _c(
                "el-col",
                { attrs: { span: 15 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        multiple: "",
                        "value-key": "id",
                        placeholder: _vm.$t("COMMON_SELECT"),
                        "collapse-tags": "",
                      },
                      model: {
                        value: _vm.cc,
                        callback: function ($$v) {
                          _vm.cc = $$v
                        },
                        expression: "cc",
                      },
                    },
                    _vm._l(
                      [..._vm.emailOptions, ..._vm.ccOptions],
                      function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.userName, value: item.id },
                        })
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
                [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  on: {
                    click: function ($event) {
                      return _vm.onConfirm(true)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("send_me_a_preview")))]
              ),
              _c(
                "el-button",
                {
                  staticClass: "wl-green",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onConfirm(false)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("comment_send")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }